module.exports = __webpack_public_path__ + "img/arrow-left-btn.0ddd0dfb.svg";